export const getCurrentLocation = () => {
  const { pathname, search, hash } = window.location;

  // vl-admin uses hash routing
  if (hash?.startsWith('#/')) {
    const hashWithoutSharp = hash.slice(1);
    const [hashPathname, hashSearch = ''] = hashWithoutSharp.split('?');

    return {
      pathname: hashPathname,
      search: hashSearch ? `?${hashSearch}` : ''
    };
  }

  const STORY_BRANCH_PREFIX = /^\/(vlnhs|vlaxa)-\d+-[^/]+-(story|bug)/;

  const cleanedPathname = pathname.replace(STORY_BRANCH_PREFIX, '');

  // vl-app has regular pathname and search
  return {
    pathname: cleanedPathname || '/',
    search
  };
};
